<template>
  <v-navigation-drawer
    v-model="isShowForm"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px;"
    stateless
  >
    <v-form
      ref="formIdentifyMode"
      class="d-flex flex-column"
      style="height: calc(100% - 64px);"
    >
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="handleClickBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item class="px-0" two-line>
          <v-list-item-content>
            <v-list-item-title>
              เลือกรูปแบบการระบุตัวตน
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ commandData.title }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto;">
        <v-autocomplete
          v-model="identifyMode"
          class="fix-google-chrome mt-3"
          :rules="[v => !!v || v === 0 || 'โปรดระบุรูปแบบการระบุตัวตน']"
          :items="identifyModeItems"
          item-text="text"
          item-value="value"
        >
          <template #label>
            รูปแบบการระบุตัวตน
            <span class="red--text"><strong>*</strong></span>
          </template>
        </v-autocomplete>
      </div>
      <v-toolbar
        flat
        color="blue-grey lighten-5"
        class="d-flex align-center justify-center"
      >
        <button @click="handleClickNext" type="button" class="mr-3">
          ถัดไป : เลือกพนักงาน
        </button>
        <div class="d-sr-only">{{ isDataChange }}</div>
        <v-icon>mdi-arrow-right</v-icon>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog
  },

  props: {
    isShowForm: {
      type: Boolean,
      required: true
    },
    commandData: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      identifyMode: null,
      identifyModeItems: [
        {
          id: 0,
          text: 'ใบหน้า',
          value: 0
        },
        {
          id: 1,
          text: 'บัตร และ ใบหน้า',
          value: 1
        },
        {
          id: 2,
          text: 'บัตร หรือ ใบหน้า',
          value: 2
        },
        {
          id: 3,
          text: 'บัตร',
          value: 3
        },
        {
          id: 4,
          text: 'รหัสพนักงาน และ ใบหน้า',
          value: 4
        },
        {
          id: 5,
          text: 'รหัสพนักงาน หรือ ใบหน้า',
          value: 5
        },
        {
          id: 6,
          text: 'รหัสพนักงาน และ บัตร',
          value: 6
        },
        {
          id: 7,
          text: 'รหัสพนักงาน หรือ บัตร',
          value: 7
        },
        {
          id: 8,
          text: 'ตามค่าเริ่มต้นของ Device',
          value: 8
        }
      ]
    }
  },

  watch: {
    commandData(newValue, oldValue) {
      if (Object.keys(newValue).length === 0) {
        this.identifyMode = null
        this.$refs.formIdentifyMode.reset()
      }
    }
  },

  computed: {
    isDataChange() {
      if (this.identifyMode || this.identifyMode === 0) {
        this.$emit('isHardwareConnectionFormIdentifyModeDataChange', true)
        return true
      } else {
        this.$emit('isHardwareConnectionFormIdentifyModeDataChange', false)
        return false
      }
    }
  },

  methods: {
    handleClickBack() {
      if (this.isDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการละทิ้งการดำเนินการทั้งหมด?',
          text:
            'คุณยังไม่ได้ดำเนินการ คุณแน่ใจหรือไม่ว่าต้องการละทิ้งการดำเนินการทั้งหมด',
          value: ''
        }
        this.confirmDialogDataChange = true
      } else {
        this.$refs.formIdentifyMode.reset()
        this.$emit('onClickBack')
      }
    },

    handleClickNext() {
      if (this.$refs.formIdentifyMode.validate()) {
        const payload = {
          ...this.commandData,
          identifyMode: this.identifyMode
        }
        this.$emit('onClickNext', payload)
      }
    },

    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },

    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
      this.$refs.formIdentifyMode.reset()
      this.identifyMode = null
      this.$emit('onClickBack')
    }
  }
}
</script>
